import React from 'react'
import { useIntl } from 'react-intl'
import { NotificationSubscriptionRow } from '.'

export function FailedScanRow({ entry, i18nTitle, i18nSubtitle, onToggle }) {
  const intl = useIntl()

  return (
    <NotificationSubscriptionRow
      entry={entry}
      title={intl.formatMessage({ id: i18nTitle })}
      subtitle={intl.formatMessage({ id: i18nSubtitle })}
      onToggle={onToggle}
    />
  )
}
